<template>
  <div class="split-stepper">
    <span class="text-muted">{{ $t('recordings.activity.split_every') }}</span>
    <span class="split-stepper__control">
      <button
        type="button"
        class="split-stepper__button"
        :disabled="state.shorterStep.value === null"
        :aria-label="$t('recordings.activity.shorter_splits')"
        @click="state.stepTo(state.shorterStep.value!)"
      >
        <span class="material-icons" aria-hidden="true">remove</span>
      </button>
      <span class="split-stepper__value"><strong>{{ splitDistanceLabel(state.step.value) }}</strong> {{ unit }}</span>
      <button
        type="button"
        class="split-stepper__button"
        :disabled="state.longerStep.value === null"
        :aria-label="$t('recordings.activity.longer_splits')"
        @click="state.stepTo(state.longerStep.value!)"
      >
        <span class="material-icons" aria-hidden="true">add</span>
      </button>
    </span>
    <i18n-t keypath="recordings.activity.split_count" tag="span" scope="global">
      <template #count><strong>{{ count }}</strong></template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { splitDistanceLabel } from '../../../utils/recordingActivity/paceSplits';
import type { PaceSplitsState } from '../usePaceSplits';

defineProps<{ state: PaceSplitsState; unit: string; count: number }>();
</script>

<style scoped>
.split-stepper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.split-stepper__control {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  border-radius: 999px;
  background: var(--gray-raised, #2a2c34);
}

.split-stepper__value {
  min-width: 4.5rem;
  text-align: center;
  white-space: nowrap;
}

.split-stepper__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #fff;
  background: var(--gray-hover, #30323b);
  border: 0;
  border-radius: 50%;
}

.split-stepper__button:disabled {
  opacity: 0.35;
  cursor: default;
}

.split-stepper__button .material-icons {
  font-size: 18px;
}
</style>
